import * as React from 'react'

interface Props {
  onHide: () => void
  width?: number | string
}

export class RightSidebar extends React.Component<React.PropsWithChildren<Props>, {}> {
  render() {
    const width = this.props.width || '400px'

    return (
      <div
        className='right-sidebar'
        key={1}
        style={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          top: 0,
          left: 0,
          zIndex: 8,
        }}
      >
        <div
          style={{
            width: `calc(100vw - ${width})`,
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
          }}
          onClick={() => this.props.onHide()}
        />
        <div
          style={{
            position: 'fixed',
            width: width,
            height: '100vh',
            top: 0,
            right: 0,
            padding: '1em',
            backgroundColor: 'white',
            color: 'black',
            overflowY: 'scroll',
            maxWidth: '100vw',
          }}
          className='background-shadow'
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}
